// extracted by mini-css-extract-plugin
module.exports = {"root":"login_root__1n5pd","logo":"login_logo__1KUef","submit":"login_submit__Wvy8S","error":"login_error__11Z-O"};